module.exports = __webpack_public_path__ + "img/logo_iotena.79de7bf6.png";